import React from 'react'
import Image from 'next/image'
import { scroller } from 'react-scroll'
import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { cloudflareLoader } from '@mc/image-cloudflare'
import styles from './Hero.module.scss'

export const Hero = ({
  title,
  subtitle,
  onPurchaseClick,
  image,
  imageMobile,
  ctaComponent,
  showSelfServe: _showSelfServe,
  onCtaClick: _onCtaClick,
  onClickSelfServe: _onClickSelfServe,
}: {
  title: string
  subtitle: string
  onPurchaseClick?: () => void
  image: {
    src: string
    width: number
    height: number
  }
  imageMobile?: {
    src: string
    width: number
    height: number
  }
  ctaComponent?: React.ReactNode
  showSelfServe?: boolean
  onCtaClick?: () => void
  onClickSelfServe?: () => void
}) => (
  <>
    <div className='d-none d-md-block position-relative'>
      <div
        className={`uncontainer d-flex justify-content-end ${styles.desktopImgContainer}`}
      >
        <div
          className='position-relative'
          style={{
            height: '60dvh',
          }}
        >
          <Image
            style={{ height: '100%', width: 'auto' }}
            src={image.src}
            width={image.width}
            height={image.height}
            alt='hero'
            loader={cloudflareLoader}
          />
          <div className={`position-absolute mc-inset-0 ${styles.fade}`} />
        </div>
      </div>

      <div className='position-absolute mc-inset-0 d-flex flex-column justify-content-end col-md-10 col-lg-8 col-xl-6 mc-mb-8'>
        <div className='mc-font-headline2'>{title}</div>
        <div className='mc-mt-6 mc-mb-10'>{subtitle}</div>
        {ctaComponent || <PurchaseCTA onPurchaseClick={onPurchaseClick} />}
      </div>
    </div>

    <div className='d-md-none position-relative'>
      <div
        className='uncontainer position-relative'
        style={{
          maxHeight: '60dvh',
          overflow: 'hidden',
          marginBottom: '150px',
        }}
      >
        <Image
          style={{ objectFit: 'contain', width: '100vw', height: 'auto' }}
          src={imageMobile?.src ?? image.src}
          width={imageMobile?.width ?? image.width}
          height={imageMobile?.height ?? image.height}
          alt='hero'
          loader={cloudflareLoader}
        />
        <div className={`position-absolute mc-inset-0 ${styles.fade}`} />
      </div>

      <div className='mc-inset-0 position-absolute d-flex flex-column justify-content-end col-md-10 col-lg-8 col-xl-6'>
        <div className='mc-font-headline2 mc-text--center'>{title}</div>
        <div className='mc-mt-6 mc-mb-10 mc-text--center'>{subtitle}</div>
        {ctaComponent || <PurchaseCTA onPurchaseClick={onPurchaseClick} />}
      </div>
    </div>
  </>
)

export const PurchaseCTA = ({
  onPurchaseClick,
}: {
  onPurchaseClick?: () => void
}) => {
  const { t } = useTranslation('@mc/next')
  return (
    <div className='d-flex flex-column flex-sm-row align-items-center justify-content-center justify-content-md-start mc-gap-4 mc-mt-6'>
      <span className='mc-text-medium'>
        {t('forBusiness.heroCTA.smallTeamText')}
      </span>
      <Button
        className='mc-corners--sm'
        onClick={() => {
          onPurchaseClick?.()
          scroller.scrollTo('pricing-section', {
            duration: 700,
            smooth: true,
            offset: -70,
          })
        }}
      >
        {t('forBusiness.heroCTA.purchaseButton')}
      </Button>
    </div>
  )
}
